/**
 * solutionStages — Missing Middle metadata for the Solution Finder.
 *
 * Maps each quick-start template to the value-transfer chain stage it
 * primarily influences, provides display names for "opportunity"
 * phrasing, and derives a qualitative recovery-potential label from a
 * template's expected outcome ranges. The framework stays invisible:
 * templates remain business-problem oriented, these just explain WHY
 * a given intervention is recommended.
 */

// Template id → chain stage (keys match lib/chainLeak CHAIN_STAGES).
export const TEMPLATE_IMPACT_STAGE = {
  reduce_turnover: 'behavior',
  boost_sales: 'capability',
  reduce_errors: 'behavior',
  accelerate_onboarding: 'capability',
  improve_safety: 'behavior',
  build_leaders: 'capability',
};

// Stage key → short badge label (micro chain + template badges).
export const STAGE_BADGE_LABELS = {
  learning: 'Learning',
  capability: 'Capability',
  behavior: 'Behavior',
  outcomes: 'Outcome',
  financial: 'Value',
};

// Stage key → "opportunity" phrasing (Current Highest Opportunity).
export const OPPORTUNITY_LABELS = {
  learning: 'Learning Engagement',
  capability: 'Capability Building',
  behavior: 'Behavior Adoption',
  outcomes: 'Outcome Conversion',
  financial: 'Value Capture',
};

/**
 * Qualitative recovery potential from a template's expected outcomes
 * (e.g. "25-50% reduction in safety incidents" → upper bound 50 →
 * "High"). Falls back to "Moderate" when no range is found.
 */
export function recoveryPotential(template) {
  const text = (template?.expected_outcomes || []).join(' ');
  const ranges = [...text.matchAll(/(\d+)\s*[-–]\s*(\d+)\s*%/g)];
  if (!ranges.length) return 'Moderate';
  const upper = Math.max(...ranges.map((m) => Number(m[2])));
  if (upper >= 30) return 'High';
  if (upper >= 15) return 'Moderate';
  return 'Emerging';
}
